import React from 'react'
import './filterSidebar.css'

// This page is a static placeholder — no bus search API exists yet, so every
// value here is hardcoded to match the reference design exactly (no state,
// no onChange, nothing actually filters). Once a bus API is available, this
// can be wired up the same way filterSidebar.jsx (flight) / carFilterSidebar.jsx are.

const RECOMMENDED_FILTERS = [
    { key: 'nonStop', label: 'Non-Stop' },
    { key: 'departureFromBhubaneswar', label: 'Departure from Bhubaneswar', subtext: '6AM - 12PM' },
    { key: 'freeMeal', label: 'Free meal available' },
]

const STOPS = [
    { key: 'nonStop', label: 'Non-Stop', priceLabel: '₹9,199' },
    { key: '1stop', label: '1 Stop', priceLabel: '₹10,330' },
    { key: '2plusStops', label: '2+ Stops', priceLabel: '₹24,331' },
]

const AIRLINES = [
    { key: 'airIndia', label: 'Air India', count: 43, priceLabel: '₹9,633' },
    { key: 'airIndiaExpress', label: 'Air-India Express', count: 7, priceLabel: '₹9,199' },
    { key: 'indigo', label: 'IndiGo', count: 15, priceLabel: '₹9,435' },
]

const ARRIVAL_AIRPORTS = [
    { key: 'del', code: 'DEL', label: 'Delhi Indira Gandhi International Airport', priceLabel: '₹9,199' },
    { key: 'hdo', code: 'HDO', label: 'Hindon Airport', subtext: '27 Km from DEL', priceLabel: '₹20,424' },
    { key: 'dxn', code: 'DXN', label: 'Noida International Airport', subtext: '66 Km from DEL', priceLabel: '₹16,627' },
]

const DEPARTURE_SLOTS = [
    { key: 'before6am', icon: 'sunrise', label: 'Before 6AM', priceLabel: null },
    { key: '6to12', icon: 'sun', label: '6AM - 12PM', priceLabel: '₹9,199', active: true },
    { key: '12to6', icon: 'sunset', label: '12PM - 6PM', priceLabel: '₹9,199' },
    { key: 'after6pm', icon: 'moon', label: 'After 6PM', priceLabel: '₹9,199' },
]

const ARRIVAL_SLOTS = [
    { key: 'before6am', icon: 'sunrise', label: 'Before 6AM', priceLabel: null },
    { key: '6to12', icon: 'sun', label: '6AM - 12PM', priceLabel: '₹9,199', active: true },
    { key: '12to6', icon: 'sunset', label: '12PM - 6PM', priceLabel: '₹9,199' },
    { key: 'after6pm', icon: 'moon', label: 'After 6PM', priceLabel: '₹9,435' },
]

const TimeIcon = ({ type }) => {
    if (type === 'sun') {
        return (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="1.6" />
                <g stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
                    <line x1="12" y1="1.5" x2="12" y2="4" />
                    <line x1="12" y1="20" x2="12" y2="22.5" />
                    <line x1="1.5" y1="12" x2="4" y2="12" />
                    <line x1="20" y1="12" x2="22.5" y2="12" />
                    <line x1="4.4" y1="4.4" x2="6.2" y2="6.2" />
                    <line x1="17.8" y1="17.8" x2="19.6" y2="19.6" />
                    <line x1="4.4" y1="19.6" x2="6.2" y2="17.8" />
                    <line x1="17.8" y1="6.2" x2="19.6" y2="4.4" />
                </g>
            </svg>
        )
    }
    if (type === 'sunset') {
        return (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M6 18a6 6 0 0 1 12 0" stroke="currentColor" strokeWidth="1.6" />
                <line x1="1.5" y1="18" x2="22.5" y2="18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                <path d="M9 21h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                <path d="M12 3v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                <path d="M4.5 8.5 7 11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                <path d="M19.5 8.5 17 11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            </svg>
        )
    }
    if (type === 'moon') {
        return (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M20 14.5A8.5 8.5 0 1 1 9.5 4 6.8 6.8 0 0 0 20 14.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
            </svg>
        )
    }
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M4 17a8 8 0 0 1 16 0" stroke="currentColor" strokeWidth="1.6" />
            <line x1="1.5" y1="17" x2="22.5" y2="17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            <path d="M8 13 12 9l4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

const BusFilterSidebar = () => {
    return (
        <div className='filterSidebar'>
            <div className='filterSidebarHead'>
                <div className='filterSidebarTitle'>Filters</div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionHead'>
                    <div className='filterSectionTitle'>Recommended Filters</div>
                    <label className='filterCheckboxAll'>
                        All
                        <input type='checkbox' readOnly />
                    </label>
                </div>
                <div className='filterList'>
                    {RECOMMENDED_FILTERS.map((item) => (
                        <label className='filterCheckRow' key={item.key}>
                            <div>
                                <div className='filterCheckLabel'>{item.label}</div>
                                {item.subtext && <div className='filterCheckSubtext'>{item.subtext}</div>}
                            </div>
                            <input type='checkbox' readOnly />
                        </label>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Stops</div>
                <div className='stopsRow'>
                    {STOPS.map((stop) => (
                        <div className='stopCard' key={stop.key}>
                            <div className='stopCardLabel'>{stop.label}</div>
                            <div className='stopCardPrice'>{stop.priceLabel}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Flight Price</div>
                <div className='rangeSlider'>
                    <div className='rangeSlider__track' />
                    <div className='rangeSlider__range' style={{ left: '0%', right: '0%' }} />
                    <input type='range' min={9199} max={35867} defaultValue={9199} readOnly />
                    <input type='range' min={9199} max={35867} defaultValue={35867} readOnly />
                </div>
                <div className='rangeLabels'>
                    <span>₹9,199</span>
                    <span>₹35,867</span>
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Duration</div>
                <div className='rangeSlider'>
                    <div className='rangeSlider__track' />
                    <div className='rangeSlider__range' style={{ left: '0%', right: '0%' }} />
                    <input type='range' min={2} max={28} defaultValue={2} readOnly />
                    <input type='range' min={2} max={28} defaultValue={28} readOnly />
                </div>
                <div className='rangeLabels'>
                    <span>2h</span>
                    <span>28h</span>
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionHead'>
                    <div className='filterSectionTitle'>Airlines</div>
                    <label className='filterCheckboxAll'>
                        All
                        <input type='checkbox' readOnly />
                    </label>
                </div>
                <div className='filterList'>
                    {AIRLINES.map((airline) => (
                        <label className='filterCheckRow' key={airline.key}>
                            <div className='filterCheckLabel'>{airline.label} ({airline.count})</div>
                            <div className='filterCheckRight'>
                                <span className='filterCheckPrice'>{airline.priceLabel}</span>
                                <input type='checkbox' readOnly />
                            </div>
                        </label>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Arrival Airport</div>
                <div className='filterList'>
                    {ARRIVAL_AIRPORTS.map((airport) => (
                        <label className='filterCheckRow' key={airport.key}>
                            <div>
                                <div className='filterCheckLabel'>{airport.code} - {airport.label}</div>
                                {airport.subtext && <div className='filterCheckSubtext'>{airport.subtext}</div>}
                            </div>
                            <div className='filterCheckRight'>
                                <span className='filterCheckPrice'>{airport.priceLabel}</span>
                                <input type='checkbox' readOnly />
                            </div>
                        </label>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Departure from Bhubaneswar</div>
                <div className='slotGrid'>
                    {DEPARTURE_SLOTS.map((slot) => (
                        <div key={slot.key} className={`slotCard ${slot.active ? 'active' : ''} ${!slot.priceLabel ? 'disabled' : ''}`}>
                            <span className='slotIcon'><TimeIcon type={slot.icon} /></span>
                            <div className='slotLabel'>{slot.label}</div>
                            <div className='slotPrice'>{slot.priceLabel || '--'}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Arrival at New Delhi</div>
                <div className='slotGrid'>
                    {ARRIVAL_SLOTS.map((slot) => (
                        <div key={slot.key} className={`slotCard ${slot.active ? 'active' : ''} ${!slot.priceLabel ? 'disabled' : ''}`}>
                            <span className='slotIcon'><TimeIcon type={slot.icon} /></span>
                            <div className='slotLabel'>{slot.label}</div>
                            <div className='slotPrice'>{slot.priceLabel || '--'}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default BusFilterSidebar
